module.exports = __webpack_public_path__ + "img/animationArrowNavy.95587316.svg";